
const CaseStudiesSlide = ({slideImg, sliderTitle, sliderDescription }) => {
    return(
        <div className="swiper-slide">
            <div className="case-study-box wow fadeInDown">
                    <h4 className="case-title">{sliderTitle}</h4>
                     <p>{sliderDescription}</p>
                    <div className="logo-box">
                        <img className="img-fluid" src={slideImg}  alt="slider logo"/>
                    </div>
             </div>
        </div>
    );
    
};
export default CaseStudiesSlide;